import React, { createContext, useContext } from 'react';

import { FormInstance } from 'antd';

import { VALUE_DIFFERENCE_DISPLAY } from 'components/View/constants';

export type CompareCommunitiesFilterFormValues = {
  comparisonTypeEnabled: boolean;
  valueDisplay: number;
};

type CompareCommunitiesFilterContextValue = {
  form: FormInstance<CompareCommunitiesFilterFormValues>;
};

export const CompareCommunitiesFilterContext = createContext<CompareCommunitiesFilterContextValue>({
  form: {} as FormInstance<CompareCommunitiesFilterFormValues>,
});

export const defaultCompareCommunitiesFilterValues: CompareCommunitiesFilterFormValues = {
  comparisonTypeEnabled: true,
  valueDisplay: VALUE_DIFFERENCE_DISPLAY.AMOUNTS,
};

export const useCompareCommunitiesFilterContext = () => useContext(CompareCommunitiesFilterContext);
